import React, { useState, useEffect } from "react";
import moment from 'moment';
import Popup from 'reactjs-popup';
import PDFMerger from 'pdf-merger-js';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleLeft, faChevronCircleRight, faIndustry } from "@fortawesome/free-solid-svg-icons";
import StudentDataService from "../../services/student/StudentService";
import LoadingSpinner from '../common/LoadingSpinner';
import 'reactjs-popup/dist/index.css';
import LessonDataService from "../../services/class/LessonService";
import PlanDataService from "../../services/class/PlanService";

const PrintPopup = ({class: incomingClass, closeCallback}) => {
  const [printClass, setPrintClass] = useState();
  const [studentsForClass, setStudentsForClass] = useState();
  const [lessons, setLessons] = useState();
  const [currentLesson, setCurrentLesson] = useState();

  const [pdfRendering, setPdfRendering] = useState(false);

  useEffect(() => {
    
    const doIt = async () => {
      const incomingStudentsForClass = await StudentDataService.getAllForClass(incomingClass.id);
      setStudentsForClass(incomingStudentsForClass);
  
      const incomingLessons = await LessonDataService.getLessonsForClass(incomingClass.id);
      setLessons(incomingLessons);
    }
    doIt();
    
  }, [incomingClass]);

  useEffect(() => {
    
    const doIt = async () => {
      //find the next lesson
      const nextLesson = lessons.filter(l => moment(l.classDate).isSameOrAfter(moment())).sort((a,b) => moment(a).valueOf() - moment(b).valueOf())?.[0];
      setCurrentLesson(nextLesson || lessons?.[lessons.length-1]);
    }
    if (lessons) {
     doIt();
    }
    
  }, [lessons]);

  useEffect(() => {
    if (studentsForClass && lessons) {
      printMaterials();
    }
    
  }, [currentLesson, studentsForClass]);

  const packageMaterials = async(emailOrPrint) => {
    if (emailOrPrint === 'email') {
      alert('email not done yet');
      return;
    }
    setPdfRendering(true);
    console.log('Packaging materials: ', printClass?.materials);

    const mergedPdf = await PlanDataService.generatePdf({printMaterials: printClass.materials});

    const url = URL.createObjectURL(mergedPdf);
    console.log(mergedPdf);
    console.log('merged url', url);

    window.open(url, `PRINT ${new Date().getTime()}`);
    setPdfRendering(false);
  }

  const packageMaterialsLocal = async(emailOrPrint) => {
    if (emailOrPrint === 'email') {
      alert('email not done yet');
      return;
    }
    setPdfRendering(true);
    console.log('Packaging materials: ', printClass?.materials);
    const merger = new PDFMerger();
    await Promise.all(
      printClass?.materials?.map(async m => {
        //return merger.add(m.url);
        const printCount = parseInt(m.printCount);
        if (printCount) {
          console.log('adding material, print count is', m.printCount);
          const tmpArray = Array(printCount).fill();
          console.log('looping', tmpArray);
          return await Promise.all(
            tmpArray.map(async (n,i) => {
              console.log('adding url:', m.url, i);
              return await merger.add(m.url);
            })
          )
        }
      })
    );
    const mergedPdf = await merger.saveAsBlob();
    const url = URL.createObjectURL(mergedPdf);
    console.log('merged url', url);

    window.open(url, `PRINT ${new Date().getTime()}`, /*"height=400,width=600"*/);
    setPdfRendering(false);
  }
  const printMaterials = async () => {
    const classToPrint = incomingClass;
    
    const levelMap = [];
    studentsForClass.forEach(s => {
      const key = parseInt(s.year).toString();
      levelMap[key] = levelMap[key] ? levelMap[key]+1 : 1;
    });

    const materials = await PlanDataService.getMaterials({byLessonNumber: currentLesson.number, bySemester: classToPrint.semester});
    
    const materialsWithCounts = materials.sort((m1, m2) => m1.name.localeCompare(m2.name)).map(m => {
      var printCount = 0;
      m.level.split(' ').forEach(l => printCount = printCount + levelMap[l] ? levelMap[l] : 0);
      return { ...m, printCount};
    });

    console.log('print materials for this class', classToPrint);
    setPrintClass({ classToPrint: classToPrint, materials: materialsWithCounts });
  }

  const changeLesson = (dir) => {
    var currentLessonIndex = lessons.indexOf(currentLesson);

    currentLessonIndex += dir;

    if (currentLessonIndex < 0) { 
      currentLessonIndex = lessons.length-1;
    } else if (currentLessonIndex >= lessons.length) {
      currentLessonIndex = 0;
    }

    setCurrentLesson(lessons[currentLessonIndex]);
  }

  const renderMaterialsList = () => {

    return (
      <div style={{maxHeight: 300, minHeight: 300, height: 300, overflowY: 'scroll', margin: 5}}>
          { 
            printClass?.materials?.length ? printClass?.materials?.map((m, i) => {
              const backgroundStyle = i%2 ? {backgroundColor: '#eee'} : {backgroundColor: '#fff'};
              return (
                <div style={{display: 'flex', flexDirection: 'row', padding: 5, ...backgroundStyle}}>
                  <div style={{flex: 2}}><a href={`${m.url}`}>{m.name}</a></div>
                  <div style={{flex: 1}}>
                    <input
                      type="text"
                      className="form-control"
                      id="total"
                      name="total"
                      value={m.printCount}
                      onChange={(e) => {
                        m.printCount = e.target.value;
                        setPrintClass({...printClass});
                      }}
                    />
                  </div>
                </div>)
            })
            : <div style={{textAlign: 'center'}}>No materials available for this week</div>
          }
          {
            pdfRendering && (
              <div style={{position: 'absolute', flexDirection: 'column', display: 'flex', left: 0, right: 0, top: 95, bottom:50, backgroundColor: '#ffffff99', alignItems: 'center', justifyContent: 'center', alignContent: 'center'}}>
                  <div style={{textAlign: 'center'}}>Generating pdf</div>
                  <div><LoadingSpinner/></div>
              </div>
            )
          }
      </div>
    )
  }

  return (
    <div>
      <Popup open={!!printClass} closeOnDocumentClick onClose={closeCallback}>
        <div style={{width: '100%'}}>
          <div style={{display: 'flex', height: 40, flexDirection: 'row', backgroundColor: 'var(--primary-light-color)', color: 'white'}}>
            <a className="close" onClick={closeCallback}>
              <div style={{fontSize: 20, color: 'white', margin: 2}}>
                <i className="fas fa-times-circle action"></i>
              </div>
            </a>
            <div style={{flex: 1, alignItems: 'center', alignContent: 'center', textAlign: 'center'}}><h4>Print Materials</h4></div>
          </div>
          <div style={{display: 'flex', height: 40, flexDirection: 'row', backgroundColor: '#aaa', margin: 10}}>
            <a onClick={() => changeLesson(-1)}>
              <div style={{fontSize: 24, margin: 2}}>
                <FontAwesomeIcon icon={faChevronCircleLeft}/>
              </div>
            </a>
            <div style={{flex: 1, alignItems: 'center', alignContent: 'center', textAlign: 'center', flexDirection: 'row', display: 'flex', margin: 10}}>
              <div style={{flex: 1, textAlign: 'center'}}>Week {currentLesson?.number} - {moment(currentLesson?.classDate).format('DD/MM/YYYY')}</div>
            </div>
            <a onClick={() => changeLesson(1)}>
              <div style={{fontSize: 24, margin: 2}}>
                <FontAwesomeIcon icon={faChevronCircleRight}/>
              </div>
            </a>
          </div>
          {renderMaterialsList()}
          <div style={{display: 'flex', flexDirection: 'row', flex: 1, justifyContet: 'space-around'}}>
            <div style={{flex: 1, justifyContent: 'center', display: 'flex'}}>
              <div>
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={() => packageMaterials('print')}
                >
                  <FontAwesomeIcon icon={faIndustry}/> Generate PDF
                </button>
              </div>
            </div>
            { false && <div style={{flex: 1, alignContent: 'flex-end', justifyContent: 'flex-end', display: 'flex'}}>
              <div>
                <button
                type="submit"
                className="btn btn-primary"
                onClick={() => packageMaterials('email')}
                >
                <i className="fas fa-envelope action"></i> Email
                </button>
              </div>
            </div>}
          </div>
        </div>
      </Popup>
    </div>
  );
}

export default PrintPopup;